/**
 * This file is auto-generated by the API client generator.
 * https://github.com/flowup/api-client-generator
 *
 * Avoid editing this file manually unless necessary.
 * Please report any bugs so they can be addressed in future versions.
 */

/* tslint:disable */
/* eslint-disable */

import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { APIClientInterface } from './api-client.interface';
import { Observable } from 'rxjs';import { DefaultHttpOptions, HttpOptions } from './types';

import * as models from './models';
export const USE_DOMAIN = new InjectionToken<string>('APIClient_USE_DOMAIN');
export const USE_HTTP_OPTIONS = new InjectionToken<HttpOptions>('APIClient_USE_HTTP_OPTIONS');

type APIHttpOptions = HttpOptions & {
  headers: HttpHeaders;
  params: HttpParams;
};

@Injectable()
export class APIClient implements APIClientInterface {

  readonly options: APIHttpOptions;

  readonly domain: string = `//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/api/v1`;

  constructor(
    private readonly http: HttpClient,
    @Optional() @Inject(USE_DOMAIN) domain?: string,
    @Optional() @Inject(USE_HTTP_OPTIONS) options?: DefaultHttpOptions,
  ) {
    if (domain != null) {
      this.domain = domain;
    }

    this.options = {
      headers: new HttpHeaders(options && options.headers ? options.headers : {}),
      params: new HttpParams(options && options.params ? options.params : {}),
      ...(options && options.reportProgress ? { reportProgress: options.reportProgress } : {}),
      ...(options && options.withCredentials ? { withCredentials: options.withCredentials } : {})
    };
  }

  /**
   * Rendszerparaméterek lekérdezése
   * Rendszerparaméterek lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getSystemSettings(
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.SystemSettingsDto>;
  getSystemSettings(
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.SystemSettingsDto>>;
  getSystemSettings(
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.SystemSettingsDto>>;
  getSystemSettings(
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.SystemSettingsDto | HttpResponse<models.SystemSettingsDto> | HttpEvent<models.SystemSettingsDto>> {
    const path = `/system/settings`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.get<models.SystemSettingsDto>(`${this.domain}${path}`, options);
  }

  /**
   * Szerződések lista
   * Szerződések lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getContracts(
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.ContractDto[]>;
  getContracts(
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.ContractDto[]>>;
  getContracts(
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.ContractDto[]>>;
  getContracts(
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.ContractDto[] | HttpResponse<models.ContractDto[]> | HttpEvent<models.ContractDto[]>> {
    const path = `/contracts`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.get<models.ContractDto[]>(`${this.domain}${path}`, options);
  }

  /**
   * Szerződés részletes adatai
   * Szerződés részletes adatainak lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getContractById(
    args: Exclude<APIClientInterface['getContractByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.ContractDto>;
  getContractById(
    args: Exclude<APIClientInterface['getContractByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.ContractDto>>;
  getContractById(
    args: Exclude<APIClientInterface['getContractByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.ContractDto>>;
  getContractById(
    args: Exclude<APIClientInterface['getContractByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.ContractDto | HttpResponse<models.ContractDto> | HttpEvent<models.ContractDto>> {
    const path = `/contracts/${args.iD}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.get<models.ContractDto>(`${this.domain}${path}`, options);
  }

  /**
   * Szerződések lista
   * Szerződések lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getContractsSearchList(
    args?: APIClientInterface['getContractsSearchListParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.ContractSearchListItemDto[]>;
  getContractsSearchList(
    args?: APIClientInterface['getContractsSearchListParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.ContractSearchListItemDto[]>>;
  getContractsSearchList(
    args?: APIClientInterface['getContractsSearchListParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.ContractSearchListItemDto[]>>;
  getContractsSearchList(
    args: APIClientInterface['getContractsSearchListParams'] = {},
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.ContractSearchListItemDto[] | HttpResponse<models.ContractSearchListItemDto[]> | HttpEvent<models.ContractSearchListItemDto[]>> {
    const path = `/contracts/search`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    if ('koopFrameContractID' in args) {
      options.params = options.params.set('koopFrameContractID', String(args.koopFrameContractID));
    }
    if ('productTypeSID' in args) {
      options.params = options.params.set('productTypeSID', String(args.productTypeSID));
    }
    if ('stateSID' in args) {
      options.params = options.params.set('stateSID', String(args.stateSID));
    }
    if ('contractorName' in args) {
      options.params = options.params.set('contractorName', String(args.contractorName));
    }
    return this.http.get<models.ContractSearchListItemDto[]>(`${this.domain}${path}`, options);
  }

  /**
   * Biztosítottak listájának frissítése szerződéshez
   * Biztosítottak listájának  frissítése szerződéshez
   * Response generated for [ 200 ] HTTP response code.
   */
  postContractsInsurantsUpload(
    args: Exclude<APIClientInterface['postContractsInsurantsUploadParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.UFOFileInfoResultDto>;
  postContractsInsurantsUpload(
    args: Exclude<APIClientInterface['postContractsInsurantsUploadParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.UFOFileInfoResultDto>>;
  postContractsInsurantsUpload(
    args: Exclude<APIClientInterface['postContractsInsurantsUploadParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.UFOFileInfoResultDto>>;
  postContractsInsurantsUpload(
    args: Exclude<APIClientInterface['postContractsInsurantsUploadParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.UFOFileInfoResultDto | HttpResponse<models.UFOFileInfoResultDto> | HttpEvent<models.UFOFileInfoResultDto>> {
    const path = `/contracts/insurants/upload`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.post<models.UFOFileInfoResultDto>(`${this.domain}${path}`, JSON.stringify(args.insurantsData), options);
  }

  /**
   * Ügynök adatai
   * Ügynök adatainak lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getContractsAgent(
    args: Exclude<APIClientInterface['getContractsAgentParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.AgentDto>;
  getContractsAgent(
    args: Exclude<APIClientInterface['getContractsAgentParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.AgentDto>>;
  getContractsAgent(
    args: Exclude<APIClientInterface['getContractsAgentParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.AgentDto>>;
  getContractsAgent(
    args: Exclude<APIClientInterface['getContractsAgentParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.AgentDto | HttpResponse<models.AgentDto> | HttpEvent<models.AgentDto>> {
    const path = `/contracts/${args.contractId}/agent`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.get<models.AgentDto>(`${this.domain}${path}`, options);
  }

  /**
   * Alszerződés részletes létszám adatai
   * Alszerződés részletes létszám adatainak lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getManpowerReportBySubContractId(
    args: Exclude<APIClientInterface['getManpowerReportBySubContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.ManpowerReportDto[]>;
  getManpowerReportBySubContractId(
    args: Exclude<APIClientInterface['getManpowerReportBySubContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.ManpowerReportDto[]>>;
  getManpowerReportBySubContractId(
    args: Exclude<APIClientInterface['getManpowerReportBySubContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.ManpowerReportDto[]>>;
  getManpowerReportBySubContractId(
    args: Exclude<APIClientInterface['getManpowerReportBySubContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.ManpowerReportDto[] | HttpResponse<models.ManpowerReportDto[]> | HttpEvent<models.ManpowerReportDto[]>> {
    const path = `/contracts/manpower/${args.subContractId}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.get<models.ManpowerReportDto[]>(`${this.domain}${path}`, options);
  }

  /**
   * Alszerződés részletes létszám adatai
   * Alszerződés részletes létszám adatainak lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getManpowerReportByKoopSubContractId(
    args: Exclude<APIClientInterface['getManpowerReportByKoopSubContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.ManpowerReportDto[]>;
  getManpowerReportByKoopSubContractId(
    args: Exclude<APIClientInterface['getManpowerReportByKoopSubContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.ManpowerReportDto[]>>;
  getManpowerReportByKoopSubContractId(
    args: Exclude<APIClientInterface['getManpowerReportByKoopSubContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.ManpowerReportDto[]>>;
  getManpowerReportByKoopSubContractId(
    args: Exclude<APIClientInterface['getManpowerReportByKoopSubContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.ManpowerReportDto[] | HttpResponse<models.ManpowerReportDto[]> | HttpEvent<models.ManpowerReportDto[]>> {
    const path = `/contracts/manpower/external/${args.koopSubContractId}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.get<models.ManpowerReportDto[]>(`${this.domain}${path}`, options);
  }

  /**
   * Keretszerződés Fitpuli aktiválás
   * A keretszerződésen aktiváljuk a Fitpuli szolgáltatást
   * Response generated for [ 200 ] HTTP response code.
   */
  activateFitpuliByContractId(
    args: Exclude<APIClientInterface['activateFitpuliByContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.ContractDto>;
  activateFitpuliByContractId(
    args: Exclude<APIClientInterface['activateFitpuliByContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.ContractDto>>;
  activateFitpuliByContractId(
    args: Exclude<APIClientInterface['activateFitpuliByContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.ContractDto>>;
  activateFitpuliByContractId(
    args: Exclude<APIClientInterface['activateFitpuliByContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.ContractDto | HttpResponse<models.ContractDto> | HttpEvent<models.ContractDto>> {
    const path = `/contracts/fitpuli/activate/${args.contractId}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.post<models.ContractDto>(`${this.domain}${path}`, null, options);
  }

  /**
   * Keretszerződés Fitpuli inaktiválás
   * A keretszerződésen inaktiváljuk a Fitpuli szolgáltatást
   * Response generated for [ 200 ] HTTP response code.
   */
  inactivateFitpuliByContractId(
    args: Exclude<APIClientInterface['inactivateFitpuliByContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.ContractDto>;
  inactivateFitpuliByContractId(
    args: Exclude<APIClientInterface['inactivateFitpuliByContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.ContractDto>>;
  inactivateFitpuliByContractId(
    args: Exclude<APIClientInterface['inactivateFitpuliByContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.ContractDto>>;
  inactivateFitpuliByContractId(
    args: Exclude<APIClientInterface['inactivateFitpuliByContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.ContractDto | HttpResponse<models.ContractDto> | HttpEvent<models.ContractDto>> {
    const path = `/contracts/fitpuli/inactivate/${args.contractId}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.post<models.ContractDto>(`${this.domain}${path}`, null, options);
  }

  /**
   * Aktív keretszerződésekhez kapcsolódó passzív keretszerződések
   * Paraméterben megadott aktív keretszerződés azonosító alapján a kapcsolódó passzív keretszerződések lekérdezése a ContractToContract táblából
   * Response generated for [ 200 ] HTTP response code.
   */
  getConnectedContracts(
    args: Exclude<APIClientInterface['getConnectedContractsParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.ContractToContractDto[]>;
  getConnectedContracts(
    args: Exclude<APIClientInterface['getConnectedContractsParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.ContractToContractDto[]>>;
  getConnectedContracts(
    args: Exclude<APIClientInterface['getConnectedContractsParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.ContractToContractDto[]>>;
  getConnectedContracts(
    args: Exclude<APIClientInterface['getConnectedContractsParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.ContractToContractDto[] | HttpResponse<models.ContractToContractDto[]> | HttpEvent<models.ContractToContractDto[]>> {
    const path = `/contracts/${args.iD}/passiveContracts`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.get<models.ContractToContractDto[]>(`${this.domain}${path}`, options);
  }

  /**
   * Aktív keretszerződésekhez kapcsolódó passzív keretszerződések mentése
   * Paraméterben megadott aktív keretszerződés azonosító alapján a kapcsolódó passzív keretszerződések mentése a ContractToContract táblába
   * Response generated for [ 200 ] HTTP response code.
   */
  saveConnectedContracts(
    args: Exclude<APIClientInterface['saveConnectedContractsParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.ContractToContractDto[]>;
  saveConnectedContracts(
    args: Exclude<APIClientInterface['saveConnectedContractsParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.ContractToContractDto[]>>;
  saveConnectedContracts(
    args: Exclude<APIClientInterface['saveConnectedContractsParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.ContractToContractDto[]>>;
  saveConnectedContracts(
    args: Exclude<APIClientInterface['saveConnectedContractsParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.ContractToContractDto[] | HttpResponse<models.ContractToContractDto[]> | HttpEvent<models.ContractToContractDto[]>> {
    const path = `/contracts/${args.iD}/passiveContracts`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.post<models.ContractToContractDto[]>(`${this.domain}${path}`, JSON.stringify(args.connectedContracts), options);
  }

  /**
   * Passzív keretszerződésekhez kapcsolódó adatok (logó) lekérdezése kulcs alapján
   * Paraméterben megadott connection key alapján a kapcsolódó PassiveContractAdministration tábla adatainak lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getContractAdministrationDataByConnectionKey(
    args: Exclude<APIClientInterface['getContractAdministrationDataByConnectionKeyParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.PassiveContractAdministrationDto>;
  getContractAdministrationDataByConnectionKey(
    args: Exclude<APIClientInterface['getContractAdministrationDataByConnectionKeyParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.PassiveContractAdministrationDto>>;
  getContractAdministrationDataByConnectionKey(
    args: Exclude<APIClientInterface['getContractAdministrationDataByConnectionKeyParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.PassiveContractAdministrationDto>>;
  getContractAdministrationDataByConnectionKey(
    args: Exclude<APIClientInterface['getContractAdministrationDataByConnectionKeyParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.PassiveContractAdministrationDto | HttpResponse<models.PassiveContractAdministrationDto> | HttpEvent<models.PassiveContractAdministrationDto>> {
    const path = `/contracts/administrationData/${args.connectionKey}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.get<models.PassiveContractAdministrationDto>(`${this.domain}${path}`, options);
  }

  /**
   * Passzív keretszerződésekhez kapcsolódó adatok (logó) lekérdezése szerződésazonosító alapján
   * Paraméterben megadott passzív keretszerződés azonosító alapján a kapcsolódó PassiveContractAdministration tábla adatainak lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getContractAdministrationData(
    args: Exclude<APIClientInterface['getContractAdministrationDataParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.PassiveContractAdministrationDto>;
  getContractAdministrationData(
    args: Exclude<APIClientInterface['getContractAdministrationDataParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.PassiveContractAdministrationDto>>;
  getContractAdministrationData(
    args: Exclude<APIClientInterface['getContractAdministrationDataParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.PassiveContractAdministrationDto>>;
  getContractAdministrationData(
    args: Exclude<APIClientInterface['getContractAdministrationDataParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.PassiveContractAdministrationDto | HttpResponse<models.PassiveContractAdministrationDto> | HttpEvent<models.PassiveContractAdministrationDto>> {
    const path = `/contracts/${args.koopPassiveFrameContractId}/administrationData`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.get<models.PassiveContractAdministrationDto>(`${this.domain}${path}`, options);
  }

  /**
   * Passzív keretszerződésekhez kapcsolódó adatok (logó) mentése
   * Paraméterben megadott passzív keretszerződés azonosító alapján a logó mentése
   * Response generated for [ 200 ] HTTP response code.
   */
  saveContractAdministrationData(
    args: Exclude<APIClientInterface['saveContractAdministrationDataParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.PassiveContractAdministrationDto>;
  saveContractAdministrationData(
    args: Exclude<APIClientInterface['saveContractAdministrationDataParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.PassiveContractAdministrationDto>>;
  saveContractAdministrationData(
    args: Exclude<APIClientInterface['saveContractAdministrationDataParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.PassiveContractAdministrationDto>>;
  saveContractAdministrationData(
    args: Exclude<APIClientInterface['saveContractAdministrationDataParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.PassiveContractAdministrationDto | HttpResponse<models.PassiveContractAdministrationDto> | HttpEvent<models.PassiveContractAdministrationDto>> {
    const path = `/contracts/${args.koopPassiveFrameContractId}/administrationData`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.put<models.PassiveContractAdministrationDto>(`${this.domain}${path}`, JSON.stringify(args.passiveContractAdministration), options);
  }

  /**
   * Passzív keretszerződés lekérdezése
   * Paraméterben megadott passzív keretszerződés azonosító alapján a keretszerződés lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getPassiveContract(
    args: Exclude<APIClientInterface['getPassiveContractParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.HIPContractDto>;
  getPassiveContract(
    args: Exclude<APIClientInterface['getPassiveContractParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.HIPContractDto>>;
  getPassiveContract(
    args: Exclude<APIClientInterface['getPassiveContractParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.HIPContractDto>>;
  getPassiveContract(
    args: Exclude<APIClientInterface['getPassiveContractParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.HIPContractDto | HttpResponse<models.HIPContractDto> | HttpEvent<models.HIPContractDto>> {
    const path = `/contracts/passiveContracts/${args.connectionKey}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.get<models.HIPContractDto>(`${this.domain}${path}`, options);
  }

  /**
   * Egyedi azonosító duplikálódásának ellenőrzése
   * Ellenőrízzük, hogy a szerződő egyedi azonosítója szerepel e már az adatbázisban, hogy kiszürjük a duplikációt
   * Response generated for [ 200 ] HTTP response code.
   */
  checkDuplicateDocumentNumbers(
    args: Exclude<APIClientInterface['checkDuplicateDocumentNumbersParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<string>;
  checkDuplicateDocumentNumbers(
    args: Exclude<APIClientInterface['checkDuplicateDocumentNumbersParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<string>>;
  checkDuplicateDocumentNumbers(
    args: Exclude<APIClientInterface['checkDuplicateDocumentNumbersParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<string>>;
  checkDuplicateDocumentNumbers(
    args: Exclude<APIClientInterface['checkDuplicateDocumentNumbersParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<string | HttpResponse<string> | HttpEvent<string>> {
    const path = `/contracts/passiveContracts/checkDuplicateDocumentNumbers`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    if ('koopFrameContractId' in args) {
      options.params = options.params.set('koopFrameContractId', String(args.koopFrameContractId));
    }
    if ('socialSecurityNumber' in args) {
      options.params = options.params.set('socialSecurityNumber', String(args.socialSecurityNumber));
    }
    if ('taxNumber' in args) {
      options.params = options.params.set('taxNumber', String(args.taxNumber));
    }
    if ('passport' in args) {
      options.params = options.params.set('passport', String(args.passport));
    }
    return this.http.get<string>(`${this.domain}${path}`, options);
  }

  /**
   * Fizetés státuszának beállítása
   * Fizetés státusz beállítása az InsuredPersonFromHIP táblában
   * Response generated for [ 200 ] HTTP response code.
   */
  setPaymentStatus(
    args: Exclude<APIClientInterface['setPaymentStatusParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<void>;
  setPaymentStatus(
    args: Exclude<APIClientInterface['setPaymentStatusParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<void>>;
  setPaymentStatus(
    args: Exclude<APIClientInterface['setPaymentStatusParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<void>>;
  setPaymentStatus(
    args: Exclude<APIClientInterface['setPaymentStatusParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<void | HttpResponse<void> | HttpEvent<void>> {
    const path = `/contracts/passiveContracts/insuredPerson`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    if ('insuredPersonFromHIPId' in args) {
      options.params = options.params.set('insuredPersonFromHIPId', String(args.insuredPersonFromHIPId));
    }
    if ('offerNumber' in args) {
      options.params = options.params.set('offerNumber', String(args.offerNumber));
    }
    if ('paymentCode' in args) {
      options.params = options.params.set('paymentCode', String(args.paymentCode));
    }
    if ('state' in args) {
      options.params = options.params.set('state', String(args.state));
    }
    return this.http.patch<void>(`${this.domain}${path}`, null, options);
  }

  /**
   * Ajánlatszám kérése és fizetés
   * Ajánlatszám kérése és fizetés
   * Response generated for [ 200 ] HTTP response code.
   */
  payInsuredPersonFromHip(
    args: Exclude<APIClientInterface['payInsuredPersonFromHipParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.StringResponseDto>;
  payInsuredPersonFromHip(
    args: Exclude<APIClientInterface['payInsuredPersonFromHipParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.StringResponseDto>>;
  payInsuredPersonFromHip(
    args: Exclude<APIClientInterface['payInsuredPersonFromHipParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.StringResponseDto>>;
  payInsuredPersonFromHip(
    args: Exclude<APIClientInterface['payInsuredPersonFromHipParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.StringResponseDto | HttpResponse<models.StringResponseDto> | HttpEvent<models.StringResponseDto>> {
    const path = `/contracts/passiveContracts/${args.insuredPersonFromHIPId}/insuredPerson`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.post<models.StringResponseDto>(`${this.domain}${path}`, null, options);
  }

  /**
   * A fizetés státuszának beállítása
   * A fizetés státuszának lekérése OnlinePaymentApi felületéről és beállítása a PBO adatbázisában
   * Response generated for [ 200 ] HTTP response code.
   */
  processPaymentResponse(
    args: Exclude<APIClientInterface['processPaymentResponseParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.StringResponseDto>;
  processPaymentResponse(
    args: Exclude<APIClientInterface['processPaymentResponseParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.StringResponseDto>>;
  processPaymentResponse(
    args: Exclude<APIClientInterface['processPaymentResponseParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.StringResponseDto>>;
  processPaymentResponse(
    args: Exclude<APIClientInterface['processPaymentResponseParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.StringResponseDto | HttpResponse<models.StringResponseDto> | HttpEvent<models.StringResponseDto>> {
    const path = `/contracts/passiveContracts/insuredPerson/payment`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.post<models.StringResponseDto>(`${this.domain}${path}`, JSON.stringify(args.providerData), options);
  }

  /**
   * Szerződés elküldése a SmartCube felé
   * Szerződés elküldése a SmartCube felé
   * Response generated for [ 200 ] HTTP response code.
   */
  sendContractFromHipById(
    args: Exclude<APIClientInterface['sendContractFromHipByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.SmartCubePDFGenerationResponseDto>;
  sendContractFromHipById(
    args: Exclude<APIClientInterface['sendContractFromHipByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.SmartCubePDFGenerationResponseDto>>;
  sendContractFromHipById(
    args: Exclude<APIClientInterface['sendContractFromHipByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.SmartCubePDFGenerationResponseDto>>;
  sendContractFromHipById(
    args: Exclude<APIClientInterface['sendContractFromHipByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.SmartCubePDFGenerationResponseDto | HttpResponse<models.SmartCubePDFGenerationResponseDto> | HttpEvent<models.SmartCubePDFGenerationResponseDto>> {
    const path = `/contracts/passiveContracts/insuredPerson/pdf/${args.insuredPersonFromHIPId}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.post<models.SmartCubePDFGenerationResponseDto>(`${this.domain}${path}`, null, options);
  }

  /**
   * Címek lekérdezése
   * Címek lekérdezése több lépcsőben
   * Response generated for [ 200 ] HTTP response code.
   */
  getAddress(
    args: Exclude<APIClientInterface['getAddressParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.CentralZIPDto[]>;
  getAddress(
    args: Exclude<APIClientInterface['getAddressParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.CentralZIPDto[]>>;
  getAddress(
    args: Exclude<APIClientInterface['getAddressParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.CentralZIPDto[]>>;
  getAddress(
    args: Exclude<APIClientInterface['getAddressParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.CentralZIPDto[] | HttpResponse<models.CentralZIPDto[]> | HttpEvent<models.CentralZIPDto[]>> {
    const path = `/contracts/address`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    if ('zip' in args) {
      options.params = options.params.set('zip', String(args.zip));
    }
    if ('city' in args) {
      options.params = options.params.set('city', String(args.city));
    }
    return this.http.get<models.CentralZIPDto[]>(`${this.domain}${path}`, options);
  }

  /**
   * Keretszerződéshez tartozó kiegészítő információk
   * Keretszerződéshez tartozó kiegészítő információk lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getContractProcessingDataByContractId(
    args: Exclude<APIClientInterface['getContractProcessingDataByContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.ContractProcessingDataDto>;
  getContractProcessingDataByContractId(
    args: Exclude<APIClientInterface['getContractProcessingDataByContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.ContractProcessingDataDto>>;
  getContractProcessingDataByContractId(
    args: Exclude<APIClientInterface['getContractProcessingDataByContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.ContractProcessingDataDto>>;
  getContractProcessingDataByContractId(
    args: Exclude<APIClientInterface['getContractProcessingDataByContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.ContractProcessingDataDto | HttpResponse<models.ContractProcessingDataDto> | HttpEvent<models.ContractProcessingDataDto>> {
    const path = `/contracts/information/${args.iD}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.get<models.ContractProcessingDataDto>(`${this.domain}${path}`, options);
  }

  /**
   * Szerződés exportálása
   * Az adott azonosítójú szerződés előkészítése exportálásra
   * Response generated for [ 200 ] HTTP response code.
   */
  insertExportQueueByContract(
    args: Exclude<APIClientInterface['insertExportQueueByContractParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.StringResponseDto>;
  insertExportQueueByContract(
    args: Exclude<APIClientInterface['insertExportQueueByContractParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.StringResponseDto>>;
  insertExportQueueByContract(
    args: Exclude<APIClientInterface['insertExportQueueByContractParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.StringResponseDto>>;
  insertExportQueueByContract(
    args: Exclude<APIClientInterface['insertExportQueueByContractParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.StringResponseDto | HttpResponse<models.StringResponseDto> | HttpEvent<models.StringResponseDto>> {
    const path = `/contracts/export/`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    if ('contractId' in args) {
      options.params = options.params.set('contractId', String(args.contractId));
    }
    return this.http.post<models.StringResponseDto>(`${this.domain}${path}`, null, options);
  }

  /**
   * Szerződésekhez tartozó kapcsolattartói adatok lekérdezése
   * Szerződésekhez tartozó kapcsolattartói adatok lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getContact(
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.ContactDto[]>;
  getContact(
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.ContactDto[]>>;
  getContact(
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.ContactDto[]>>;
  getContact(
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.ContactDto[] | HttpResponse<models.ContactDto[]> | HttpEvent<models.ContactDto[]>> {
    const path = `/contact`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.get<models.ContactDto[]>(`${this.domain}${path}`, options);
  }

  /**
   * Folyamatban lévő hívás lekérdezése
   * Folyamatban lévő hívás lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getInProgressCall(
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.NaturalPersonContactDto>;
  getInProgressCall(
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.NaturalPersonContactDto>>;
  getInProgressCall(
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.NaturalPersonContactDto>>;
  getInProgressCall(
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.NaturalPersonContactDto | HttpResponse<models.NaturalPersonContactDto> | HttpEvent<models.NaturalPersonContactDto>> {
    const path = `/contact/call`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.get<models.NaturalPersonContactDto>(`${this.domain}${path}`, options);
  }

  /**
   * Hívás lezárása
   * Hívás lezárása
   * Response generated for [ 204 ] HTTP response code.
   */
  closeCall(
    args: Exclude<APIClientInterface['closeCallParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<void>;
  closeCall(
    args: Exclude<APIClientInterface['closeCallParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<void>>;
  closeCall(
    args: Exclude<APIClientInterface['closeCallParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<void>>;
  closeCall(
    args: Exclude<APIClientInterface['closeCallParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<void | HttpResponse<void> | HttpEvent<void>> {
    const path = `/contact/call/${args.callId}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.post<void>(`${this.domain}${path}`, JSON.stringify(args.meta), options);
  }

  /**
   * Ügy adatok lekérdzése
   * Ügy adatok lekérdzése
   * Response generated for [ 200 ] HTTP response code.
   */
  getCaseData(
    args: Exclude<APIClientInterface['getCaseDataParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.NaturalPersonContactCaseDto>;
  getCaseData(
    args: Exclude<APIClientInterface['getCaseDataParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.NaturalPersonContactCaseDto>>;
  getCaseData(
    args: Exclude<APIClientInterface['getCaseDataParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.NaturalPersonContactCaseDto>>;
  getCaseData(
    args: Exclude<APIClientInterface['getCaseDataParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.NaturalPersonContactCaseDto | HttpResponse<models.NaturalPersonContactCaseDto> | HttpEvent<models.NaturalPersonContactCaseDto>> {
    const path = `/contact/case`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.post<models.NaturalPersonContactCaseDto>(`${this.domain}${path}`, JSON.stringify(args.caseData), options);
  }

  /**
   * Ügy létrehozása || Ügy folytatása
   * Ügy létrehozása || Ügy folytatása
   * Response generated for [ 200 ] HTTP response code.
   */
  createCase(
    args: Exclude<APIClientInterface['createCaseParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.NaturalPersonContactDto>;
  createCase(
    args: Exclude<APIClientInterface['createCaseParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.NaturalPersonContactDto>>;
  createCase(
    args: Exclude<APIClientInterface['createCaseParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.NaturalPersonContactDto>>;
  createCase(
    args: Exclude<APIClientInterface['createCaseParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.NaturalPersonContactDto | HttpResponse<models.NaturalPersonContactDto> | HttpEvent<models.NaturalPersonContactDto>> {
    const path = `/contact/case/${args.callId}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.post<models.NaturalPersonContactDto>(`${this.domain}${path}`, JSON.stringify(args.meta), options);
  }

  /**
   * Következő ügy létrehozása
   * Következő ügy létrehozása
   * Response generated for [ 200 ] HTTP response code.
   */
  createNextCase(
    args: Exclude<APIClientInterface['createNextCaseParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.NaturalPersonContactDto>;
  createNextCase(
    args: Exclude<APIClientInterface['createNextCaseParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.NaturalPersonContactDto>>;
  createNextCase(
    args: Exclude<APIClientInterface['createNextCaseParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.NaturalPersonContactDto>>;
  createNextCase(
    args: Exclude<APIClientInterface['createNextCaseParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.NaturalPersonContactDto | HttpResponse<models.NaturalPersonContactDto> | HttpEvent<models.NaturalPersonContactDto>> {
    const path = `/contact/case/next/${args.callId}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.post<models.NaturalPersonContactDto>(`${this.domain}${path}`, JSON.stringify(args.meta), options);
  }

  /**
   * Biztosítottak listájának lekérdezése
   * Biztosítottak listájának lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getInsurants(
    args?: APIClientInterface['getInsurantsParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.PagedNaturalPersonDto>;
  getInsurants(
    args?: APIClientInterface['getInsurantsParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.PagedNaturalPersonDto>>;
  getInsurants(
    args?: APIClientInterface['getInsurantsParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.PagedNaturalPersonDto>>;
  getInsurants(
    args: APIClientInterface['getInsurantsParams'] = {},
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.PagedNaturalPersonDto | HttpResponse<models.PagedNaturalPersonDto> | HttpEvent<models.PagedNaturalPersonDto>> {
    const path = `/insurants`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.post<models.PagedNaturalPersonDto>(`${this.domain}${path}`, JSON.stringify(args.meta), options);
  }

  /**
   * Biztosított adatainak lekérdezése
   * Biztosított adatainak lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getInsurantById(
    args: Exclude<APIClientInterface['getInsurantByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.NaturalPersonDto>;
  getInsurantById(
    args: Exclude<APIClientInterface['getInsurantByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.NaturalPersonDto>>;
  getInsurantById(
    args: Exclude<APIClientInterface['getInsurantByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.NaturalPersonDto>>;
  getInsurantById(
    args: Exclude<APIClientInterface['getInsurantByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.NaturalPersonDto | HttpResponse<models.NaturalPersonDto> | HttpEvent<models.NaturalPersonDto>> {
    const path = `/insurants/${args.iD}/`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    if ('isPassive' in args) {
      options.params = options.params.set('isPassive', String(args.isPassive));
    }
    return this.http.get<models.NaturalPersonDto>(`${this.domain}${path}`, options);
  }

  /**
   * Biztosított adatainak módosítása
   * Biztosított adatainak módosítása
   * Response generated for [ 200 ] HTTP response code.
   */
  patchInsurantById(
    args: Exclude<APIClientInterface['patchInsurantByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.NaturalPersonDto>;
  patchInsurantById(
    args: Exclude<APIClientInterface['patchInsurantByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.NaturalPersonDto>>;
  patchInsurantById(
    args: Exclude<APIClientInterface['patchInsurantByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.NaturalPersonDto>>;
  patchInsurantById(
    args: Exclude<APIClientInterface['patchInsurantByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.NaturalPersonDto | HttpResponse<models.NaturalPersonDto> | HttpEvent<models.NaturalPersonDto>> {
    const path = `/insurants/${args.iD}/`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.patch<models.NaturalPersonDto>(`${this.domain}${path}`, JSON.stringify(args.insurantsData), options);
  }

  /**
   * Biztosított adatainak kényszerített módosítása
   * Biztosított adatainak kényszerített módosítása
   * Response generated for [ 200 ] HTTP response code.
   */
  putInsurantById(
    args: Exclude<APIClientInterface['putInsurantByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.NaturalPersonDto>;
  putInsurantById(
    args: Exclude<APIClientInterface['putInsurantByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.NaturalPersonDto>>;
  putInsurantById(
    args: Exclude<APIClientInterface['putInsurantByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.NaturalPersonDto>>;
  putInsurantById(
    args: Exclude<APIClientInterface['putInsurantByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.NaturalPersonDto | HttpResponse<models.NaturalPersonDto> | HttpEvent<models.NaturalPersonDto>> {
    const path = `/insurants/${args.iD}/`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.put<models.NaturalPersonDto>(`${this.domain}${path}`, JSON.stringify(args.validatedNaturalPersonDto), options);
  }

  /**
   * Új biztosított felvétele
   * Új biztosított felvétele
   * Response generated for [ 200 ] HTTP response code.
   */
  createInsurant(
    args: Exclude<APIClientInterface['createInsurantParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.NaturalPersonDto>;
  createInsurant(
    args: Exclude<APIClientInterface['createInsurantParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.NaturalPersonDto>>;
  createInsurant(
    args: Exclude<APIClientInterface['createInsurantParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.NaturalPersonDto>>;
  createInsurant(
    args: Exclude<APIClientInterface['createInsurantParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.NaturalPersonDto | HttpResponse<models.NaturalPersonDto> | HttpEvent<models.NaturalPersonDto>> {
    const path = `/insurants/create`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.post<models.NaturalPersonDto>(`${this.domain}${path}`, JSON.stringify(args.insurantsData), options);
  }

  /**
   * Új biztosított felvétele (figyelmeztetésekkel)
   * Új biztosított felvétele (figyelmeztetésekkel)
   * Response generated for [ 200 ] HTTP response code.
   */
  forceCreateInsurant(
    args: Exclude<APIClientInterface['forceCreateInsurantParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.NaturalPersonDto>;
  forceCreateInsurant(
    args: Exclude<APIClientInterface['forceCreateInsurantParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.NaturalPersonDto>>;
  forceCreateInsurant(
    args: Exclude<APIClientInterface['forceCreateInsurantParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.NaturalPersonDto>>;
  forceCreateInsurant(
    args: Exclude<APIClientInterface['forceCreateInsurantParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.NaturalPersonDto | HttpResponse<models.NaturalPersonDto> | HttpEvent<models.NaturalPersonDto>> {
    const path = `/insurants/create`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.put<models.NaturalPersonDto>(`${this.domain}${path}`, JSON.stringify(args.validatedNaturalPersonDto), options);
  }

  /**
   * Biztosítottak keresési lista
   * Biztosítottak keresési lista
   * Response generated for [ 200 ] HTTP response code.
   */
  getInsurantsSearchList(
    args?: APIClientInterface['getInsurantsSearchListParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.PagedInsurantsSearchListItemDto>;
  getInsurantsSearchList(
    args?: APIClientInterface['getInsurantsSearchListParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.PagedInsurantsSearchListItemDto>>;
  getInsurantsSearchList(
    args?: APIClientInterface['getInsurantsSearchListParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.PagedInsurantsSearchListItemDto>>;
  getInsurantsSearchList(
    args: APIClientInterface['getInsurantsSearchListParams'] = {},
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.PagedInsurantsSearchListItemDto | HttpResponse<models.PagedInsurantsSearchListItemDto> | HttpEvent<models.PagedInsurantsSearchListItemDto>> {
    const path = `/insurants/search`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    if ('name' in args) {
      options.params = options.params.set('name', String(args.name));
    }
    return this.http.post<models.PagedInsurantsSearchListItemDto>(`${this.domain}${path}`, JSON.stringify(args.meta), options);
  }

  /**
   * Biztosítottak listájának lekérdezése
   * Biztosítottak listájának lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getInsurantsSearchListByFrameContractId(
    args: Exclude<APIClientInterface['getInsurantsSearchListByFrameContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.PagedInsurantsSearchListItemDto>;
  getInsurantsSearchListByFrameContractId(
    args: Exclude<APIClientInterface['getInsurantsSearchListByFrameContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.PagedInsurantsSearchListItemDto>>;
  getInsurantsSearchListByFrameContractId(
    args: Exclude<APIClientInterface['getInsurantsSearchListByFrameContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.PagedInsurantsSearchListItemDto>>;
  getInsurantsSearchListByFrameContractId(
    args: Exclude<APIClientInterface['getInsurantsSearchListByFrameContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.PagedInsurantsSearchListItemDto | HttpResponse<models.PagedInsurantsSearchListItemDto> | HttpEvent<models.PagedInsurantsSearchListItemDto>> {
    const path = `/insurants/search/${args.frameId}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    if ('name' in args) {
      options.params = options.params.set('name', String(args.name));
    }
    return this.http.post<models.PagedInsurantsSearchListItemDto>(`${this.domain}${path}`, JSON.stringify(args.meta), options);
  }

  /**
   * Biztosítottak listájának lekérdezése
   * Biztosítottak listájának lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getInsurantsSearchListByFrameAndSubContractId(
    args: Exclude<APIClientInterface['getInsurantsSearchListByFrameAndSubContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.PagedInsurantsSearchListItemDto>;
  getInsurantsSearchListByFrameAndSubContractId(
    args: Exclude<APIClientInterface['getInsurantsSearchListByFrameAndSubContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.PagedInsurantsSearchListItemDto>>;
  getInsurantsSearchListByFrameAndSubContractId(
    args: Exclude<APIClientInterface['getInsurantsSearchListByFrameAndSubContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.PagedInsurantsSearchListItemDto>>;
  getInsurantsSearchListByFrameAndSubContractId(
    args: Exclude<APIClientInterface['getInsurantsSearchListByFrameAndSubContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.PagedInsurantsSearchListItemDto | HttpResponse<models.PagedInsurantsSearchListItemDto> | HttpEvent<models.PagedInsurantsSearchListItemDto>> {
    const path = `/insurants/search/${args.frameId}/${args.subId}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    if ('name' in args) {
      options.params = options.params.set('name', String(args.name));
    }
    return this.http.post<models.PagedInsurantsSearchListItemDto>(`${this.domain}${path}`, JSON.stringify(args.meta), options);
  }

  /**
   * Biztosított törlése
   * Biztosított törlése
   * Response generated for [ 204 ] HTTP response code.
   */
  deleteInsurant(
    args: Exclude<APIClientInterface['deleteInsurantParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<void>;
  deleteInsurant(
    args: Exclude<APIClientInterface['deleteInsurantParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<void>>;
  deleteInsurant(
    args: Exclude<APIClientInterface['deleteInsurantParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<void>>;
  deleteInsurant(
    args: Exclude<APIClientInterface['deleteInsurantParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<void | HttpResponse<void> | HttpEvent<void>> {
    const path = `/insurants/delete/${args.insurantsId}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.delete<void>(`${this.domain}${path}`, options);
  }

  /**
   * Biztosítottak listájának exportja
   * Biztosítottak listájának exportja
   * Response generated for [ 200 ] HTTP response code.
   */
  getInsurantsExportByFrameAndSubContractId(
    args: Exclude<APIClientInterface['getInsurantsExportByFrameAndSubContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.FileDto>;
  getInsurantsExportByFrameAndSubContractId(
    args: Exclude<APIClientInterface['getInsurantsExportByFrameAndSubContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.FileDto>>;
  getInsurantsExportByFrameAndSubContractId(
    args: Exclude<APIClientInterface['getInsurantsExportByFrameAndSubContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.FileDto>>;
  getInsurantsExportByFrameAndSubContractId(
    args: Exclude<APIClientInterface['getInsurantsExportByFrameAndSubContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.FileDto | HttpResponse<models.FileDto> | HttpEvent<models.FileDto>> {
    const path = `/insurants/search/${args.frameId}/${args.subId}/export`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    if ('name' in args) {
      options.params = options.params.set('name', String(args.name));
    }
    return this.http.post<models.FileDto>(`${this.domain}${path}`, JSON.stringify(args.meta), options);
  }

  /**
   * Biztosítottak listájának exportja
   * Biztosítottak listájának exportja
   * Response generated for [ 200 ] HTTP response code.
   */
  getInsurantsSearchExportByFrameContractId(
    args: Exclude<APIClientInterface['getInsurantsSearchExportByFrameContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.FileDto>;
  getInsurantsSearchExportByFrameContractId(
    args: Exclude<APIClientInterface['getInsurantsSearchExportByFrameContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.FileDto>>;
  getInsurantsSearchExportByFrameContractId(
    args: Exclude<APIClientInterface['getInsurantsSearchExportByFrameContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.FileDto>>;
  getInsurantsSearchExportByFrameContractId(
    args: Exclude<APIClientInterface['getInsurantsSearchExportByFrameContractIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.FileDto | HttpResponse<models.FileDto> | HttpEvent<models.FileDto>> {
    const path = `/insurants/search/${args.frameId}/export`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    if ('name' in args) {
      options.params = options.params.set('name', String(args.name));
    }
    return this.http.post<models.FileDto>(`${this.domain}${path}`, JSON.stringify(args.meta), options);
  }

  /**
   * Biztosítottak keresési lista export
   * Biztosítottak keresési lista export
   * Response generated for [ 200 ] HTTP response code.
   */
  getInsurantsSearchExport(
    args?: APIClientInterface['getInsurantsSearchExportParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.FileDto>;
  getInsurantsSearchExport(
    args?: APIClientInterface['getInsurantsSearchExportParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.FileDto>>;
  getInsurantsSearchExport(
    args?: APIClientInterface['getInsurantsSearchExportParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.FileDto>>;
  getInsurantsSearchExport(
    args: APIClientInterface['getInsurantsSearchExportParams'] = {},
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.FileDto | HttpResponse<models.FileDto> | HttpEvent<models.FileDto>> {
    const path = `/insurants/search/export`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    if ('name' in args) {
      options.params = options.params.set('name', String(args.name));
    }
    return this.http.post<models.FileDto>(`${this.domain}${path}`, JSON.stringify(args.meta), options);
  }

  /**
   * Biztosított biztosítási időszakaszainak lekérdezése
   * Biztosított biztosítási időszakaszainak lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getInsurancePeriodsByInsurantId(
    args: Exclude<APIClientInterface['getInsurancePeriodsByInsurantIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.InsurancePeriodDto[]>;
  getInsurancePeriodsByInsurantId(
    args: Exclude<APIClientInterface['getInsurancePeriodsByInsurantIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.InsurancePeriodDto[]>>;
  getInsurancePeriodsByInsurantId(
    args: Exclude<APIClientInterface['getInsurancePeriodsByInsurantIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.InsurancePeriodDto[]>>;
  getInsurancePeriodsByInsurantId(
    args: Exclude<APIClientInterface['getInsurancePeriodsByInsurantIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.InsurancePeriodDto[] | HttpResponse<models.InsurancePeriodDto[]> | HttpEvent<models.InsurancePeriodDto[]>> {
    const path = `/insurants/period/${args.insurantId}/`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.get<models.InsurancePeriodDto[]>(`${this.domain}${path}`, options);
  }

  /**
   * Biztosított biztosítási időszakának létrehozása
   * Biztosított biztosítási időszakának létrehozása
   * Response generated for [ 200 ] HTTP response code.
   */
  createInsurancePeriodByInsurantId(
    args: Exclude<APIClientInterface['createInsurancePeriodByInsurantIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.InsurancePeriodDto[]>;
  createInsurancePeriodByInsurantId(
    args: Exclude<APIClientInterface['createInsurancePeriodByInsurantIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.InsurancePeriodDto[]>>;
  createInsurancePeriodByInsurantId(
    args: Exclude<APIClientInterface['createInsurancePeriodByInsurantIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.InsurancePeriodDto[]>>;
  createInsurancePeriodByInsurantId(
    args: Exclude<APIClientInterface['createInsurancePeriodByInsurantIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.InsurancePeriodDto[] | HttpResponse<models.InsurancePeriodDto[]> | HttpEvent<models.InsurancePeriodDto[]>> {
    const path = `/insurants/period/${args.insurantId}/`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.post<models.InsurancePeriodDto[]>(`${this.domain}${path}`, JSON.stringify(args.insurancePeriod), options);
  }

  /**
   * HIP felületen a biztosított mentése
   * HIP felületről érkező biztosítotti adatok mentése
   * Response generated for [ 200 ] HTTP response code.
   */
  saveInsuredPersonFromHip(
    args: Exclude<APIClientInterface['saveInsuredPersonFromHipParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.HIPInsuredPersonFromHIPDto>;
  saveInsuredPersonFromHip(
    args: Exclude<APIClientInterface['saveInsuredPersonFromHipParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.HIPInsuredPersonFromHIPDto>>;
  saveInsuredPersonFromHip(
    args: Exclude<APIClientInterface['saveInsuredPersonFromHipParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.HIPInsuredPersonFromHIPDto>>;
  saveInsuredPersonFromHip(
    args: Exclude<APIClientInterface['saveInsuredPersonFromHipParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.HIPInsuredPersonFromHIPDto | HttpResponse<models.HIPInsuredPersonFromHIPDto> | HttpEvent<models.HIPInsuredPersonFromHIPDto>> {
    const path = `/insurants/hip/`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.put<models.HIPInsuredPersonFromHIPDto>(`${this.domain}${path}`, JSON.stringify(args.insuredPerson), options);
  }

  /**
   * Biztosított lekérése a HIP felületről
   * Biztosított lekérése a HIP felületről azonosító, ajánlati szám és fizetési szám alapján
   * Response generated for [ 200 ] HTTP response code.
   */
  getInsuredPersonFromHipQuery(
    args?: APIClientInterface['getInsuredPersonFromHipQueryParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.HIPInsuredPersonFromHIPDto>;
  getInsuredPersonFromHipQuery(
    args?: APIClientInterface['getInsuredPersonFromHipQueryParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.HIPInsuredPersonFromHIPDto>>;
  getInsuredPersonFromHipQuery(
    args?: APIClientInterface['getInsuredPersonFromHipQueryParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.HIPInsuredPersonFromHIPDto>>;
  getInsuredPersonFromHipQuery(
    args: APIClientInterface['getInsuredPersonFromHipQueryParams'] = {},
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.HIPInsuredPersonFromHIPDto | HttpResponse<models.HIPInsuredPersonFromHIPDto> | HttpEvent<models.HIPInsuredPersonFromHIPDto>> {
    const path = `/insurants/hip/`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    if ('insuredPersonFromHIPId' in args) {
      options.params = options.params.set('insuredPersonFromHIPId', String(args.insuredPersonFromHIPId));
    }
    if ('offerNumber' in args) {
      options.params = options.params.set('offerNumber', String(args.offerNumber));
    }
    if ('paymentCode' in args) {
      options.params = options.params.set('paymentCode', String(args.paymentCode));
    }
    if ('interruptionId' in args) {
      options.params = options.params.set('interruptionId', String(args.interruptionId));
    }
    return this.http.get<models.HIPInsuredPersonFromHIPDto>(`${this.domain}${path}`, options);
  }

  /**
   * Munkavállaló ellenőrzése
   * A munkavállaló ellenőrzése a HIP felületről
   * Response generated for [ 200 ] HTTP response code.
   */
  checkEmployee(
    args: Exclude<APIClientInterface['checkEmployeeParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.HIPEmployeeDto>;
  checkEmployee(
    args: Exclude<APIClientInterface['checkEmployeeParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.HIPEmployeeDto>>;
  checkEmployee(
    args: Exclude<APIClientInterface['checkEmployeeParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.HIPEmployeeDto>>;
  checkEmployee(
    args: Exclude<APIClientInterface['checkEmployeeParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.HIPEmployeeDto | HttpResponse<models.HIPEmployeeDto> | HttpEvent<models.HIPEmployeeDto>> {
    const path = `/insurants/hip/employee/${args.passiveKoopFrameContractId}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    if ('name' in args) {
      options.params = options.params.set('name', String(args.name));
    }
    if ('birthDate' in args) {
      options.params = options.params.set('birthDate', String(args.birthDate));
    }
    return this.http.get<models.HIPEmployeeDto>(`${this.domain}${path}`, options);
  }

  /**
   * Biztosítotti jogviszonyt igazoló email küldése
   * Biztosított ellenőrzése, biztosítotti jogviszonyt igazoló email összeállítása és továbbítása küldésre
   * Response generated for [ 200 ] HTTP response code.
   */
  sendProofOfInsurance(
    args: Exclude<APIClientInterface['sendProofOfInsuranceParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.StringResponseDto>;
  sendProofOfInsurance(
    args: Exclude<APIClientInterface['sendProofOfInsuranceParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.StringResponseDto>>;
  sendProofOfInsurance(
    args: Exclude<APIClientInterface['sendProofOfInsuranceParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.StringResponseDto>>;
  sendProofOfInsurance(
    args: Exclude<APIClientInterface['sendProofOfInsuranceParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.StringResponseDto | HttpResponse<models.StringResponseDto> | HttpEvent<models.StringResponseDto>> {
    const path = `/insurants/sendProofOfInsurance/`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    if ('iD' in args) {
      options.params = options.params.set('iD', String(args.iD));
    }
    if ('isPassive' in args) {
      options.params = options.params.set('isPassive', String(args.isPassive));
    }
    return this.http.get<models.StringResponseDto>(`${this.domain}${path}`, options);
  }

  /**
   * Userhez tartozó adatok lekérdezése
   * Userhez tartozó adatok lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getProfile(
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.ProfileDto>;
  getProfile(
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.ProfileDto>>;
  getProfile(
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.ProfileDto>>;
  getProfile(
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.ProfileDto | HttpResponse<models.ProfileDto> | HttpEvent<models.ProfileDto>> {
    const path = `/profile`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.get<models.ProfileDto>(`${this.domain}${path}`, options);
  }

  /**
   * HR adminisztrátorok listájának lekérdezése
   * HR adminisztrátorok listájának lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getUsers(
    args?: APIClientInterface['getUsersParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.CirUserDto[]>;
  getUsers(
    args?: APIClientInterface['getUsersParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.CirUserDto[]>>;
  getUsers(
    args?: APIClientInterface['getUsersParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.CirUserDto[]>>;
  getUsers(
    args: APIClientInterface['getUsersParams'] = {},
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.CirUserDto[] | HttpResponse<models.CirUserDto[]> | HttpEvent<models.CirUserDto[]>> {
    const path = `/users`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.post<models.CirUserDto[]>(`${this.domain}${path}`, JSON.stringify(args.meta), options);
  }

  /**
   * HR adminisztrátor adatainak lekérdezése
   * HR adminisztrátor adatainak lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getUserById(
    args: Exclude<APIClientInterface['getUserByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.UserDetailsDto>;
  getUserById(
    args: Exclude<APIClientInterface['getUserByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.UserDetailsDto>>;
  getUserById(
    args: Exclude<APIClientInterface['getUserByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.UserDetailsDto>>;
  getUserById(
    args: Exclude<APIClientInterface['getUserByIdParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.UserDetailsDto | HttpResponse<models.UserDetailsDto> | HttpEvent<models.UserDetailsDto>> {
    const path = `/users/${args.userId}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.get<models.UserDetailsDto>(`${this.domain}${path}`, options);
  }

  /**
   * HR adminisztrátor szerződéshez rendelése
   * HR adminisztrátor szerződéshez rendelése
   * Response generated for [ 204 ] HTTP response code.
   */
  addUserToContract(
    args: Exclude<APIClientInterface['addUserToContractParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<void>;
  addUserToContract(
    args: Exclude<APIClientInterface['addUserToContractParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<void>>;
  addUserToContract(
    args: Exclude<APIClientInterface['addUserToContractParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<void>>;
  addUserToContract(
    args: Exclude<APIClientInterface['addUserToContractParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<void | HttpResponse<void> | HttpEvent<void>> {
    const path = `/users/${args.userId}/contracts/${args.contractId}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.post<void>(`${this.domain}${path}`, null, options);
  }

  /**
   * HR adminisztrátor szerződésről levétele
   * HR adminisztrátor szerződésről levétele
   * Response generated for [ 204 ] HTTP response code.
   */
  removeUserFromContract(
    args: Exclude<APIClientInterface['removeUserFromContractParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<void>;
  removeUserFromContract(
    args: Exclude<APIClientInterface['removeUserFromContractParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<void>>;
  removeUserFromContract(
    args: Exclude<APIClientInterface['removeUserFromContractParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<void>>;
  removeUserFromContract(
    args: Exclude<APIClientInterface['removeUserFromContractParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<void | HttpResponse<void> | HttpEvent<void>> {
    const path = `/users/${args.userId}/contracts/${args.contractId}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.delete<void>(`${this.domain}${path}`, options);
  }

  /**
   * HR adminisztrátor létrhozása
   * HR adminisztrátor létrhozása
   * Response generated for [ 200 ] HTTP response code.
   */
  createPBOUser(
    args?: APIClientInterface['createPBOUserParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.CirUserDto>;
  createPBOUser(
    args?: APIClientInterface['createPBOUserParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.CirUserDto>>;
  createPBOUser(
    args?: APIClientInterface['createPBOUserParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.CirUserDto>>;
  createPBOUser(
    args: APIClientInterface['createPBOUserParams'] = {},
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.CirUserDto | HttpResponse<models.CirUserDto> | HttpEvent<models.CirUserDto>> {
    const path = `/users/create`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.post<models.CirUserDto>(`${this.domain}${path}`, JSON.stringify(args.userData), options);
  }

  /**
   * User jelszavának érvényessége, és az url ahol megváltoztatható.
   * User jelszavának érvényessége, és az url ahol megváltoztatható.
   * Response generated for [ 200 ] HTTP response code.
   */
  passwordChange(
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.PasswordChangeDto>;
  passwordChange(
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.PasswordChangeDto>>;
  passwordChange(
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.PasswordChangeDto>>;
  passwordChange(
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.PasswordChangeDto | HttpResponse<models.PasswordChangeDto> | HttpEvent<models.PasswordChangeDto>> {
    const path = `/users/passwordChange`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.get<models.PasswordChangeDto>(`${this.domain}${path}`, options);
  }

  /**
   * Üzenet küldése
   * Üzenet küldése
   * Response generated for [ 204 ] HTTP response code.
   */
  postMessage(
    args: Exclude<APIClientInterface['postMessageParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<void>;
  postMessage(
    args: Exclude<APIClientInterface['postMessageParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<void>>;
  postMessage(
    args: Exclude<APIClientInterface['postMessageParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<void>>;
  postMessage(
    args: Exclude<APIClientInterface['postMessageParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<void | HttpResponse<void> | HttpEvent<void>> {
    const path = `/message/send`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    if ('koopFrameContractId' in args) {
      options.params = options.params.set('koopFrameContractId', String(args.koopFrameContractId));
    }
    return this.http.post<void>(`${this.domain}${path}`, JSON.stringify(args.message), options);
  }

  /**
   * JWT token visszakérése
   * JWT token visszakérése
   * Response generated for [ 200 ] HTTP response code.
   */
  retrieveJwt(
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.JWTDto>;
  retrieveJwt(
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.JWTDto>>;
  retrieveJwt(
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.JWTDto>>;
  retrieveJwt(
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.JWTDto | HttpResponse<models.JWTDto> | HttpEvent<models.JWTDto>> {
    const path = `/authorization`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.get<models.JWTDto>(`${this.domain}${path}`, options);
  }

  /**
   * SmartCube dokumentum lekérdezés
   * SmartCube dokumentum lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getDocument(
    args: Exclude<APIClientInterface['getDocumentParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.HIPFileDto>;
  getDocument(
    args: Exclude<APIClientInterface['getDocumentParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.HIPFileDto>>;
  getDocument(
    args: Exclude<APIClientInterface['getDocumentParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.HIPFileDto>>;
  getDocument(
    args: Exclude<APIClientInterface['getDocumentParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.HIPFileDto | HttpResponse<models.HIPFileDto> | HttpEvent<models.HIPFileDto>> {
    const path = `/smartcube/document/${args.boxId}/${args.koopFrameContractId}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.get<models.HIPFileDto>(`${this.domain}${path}`, options);
  }

  /**
   * Szerződéshez tartozó dokumentumok lekérdezése
   * A művelet a megadott keretszerződésazonosító alapján összeállítja a kötéshez szükséges dokumentumok listáját. Majd előállítja az összefűzött dokumentumot.
   * Response generated for [ 200 ] HTTP response code.
   */
  getDocuments(
    args: Exclude<APIClientInterface['getDocumentsParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.HIPFileDto>;
  getDocuments(
    args: Exclude<APIClientInterface['getDocumentsParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.HIPFileDto>>;
  getDocuments(
    args: Exclude<APIClientInterface['getDocumentsParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.HIPFileDto>>;
  getDocuments(
    args: Exclude<APIClientInterface['getDocumentsParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.HIPFileDto | HttpResponse<models.HIPFileDto> | HttpEvent<models.HIPFileDto>> {
    const path = `/smartcube/documents/${args.koopFrameContractId}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    if ('contractGroupId' in args) {
      options.params = options.params.set('contractGroupId', String(args.contractGroupId));
    }
    return this.http.get<models.HIPFileDto>(`${this.domain}${path}`, options);
  }

  /**
   * Captcha lekérdezés.
   * A művelet lekérdez és visszaad egy új captcha kódot.
   * Response generated for [ 200 ] HTTP response code.
   */
  getCaptcha(
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.GetCaptchaStyledResultDto>;
  getCaptcha(
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.GetCaptchaStyledResultDto>>;
  getCaptcha(
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.GetCaptchaStyledResultDto>>;
  getCaptcha(
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.GetCaptchaStyledResultDto | HttpResponse<models.GetCaptchaStyledResultDto> | HttpEvent<models.GetCaptchaStyledResultDto>> {
    const path = `/onlinepayment/getcaptcha`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.get<models.GetCaptchaStyledResultDto>(`${this.domain}${path}`, options);
  }

  /**
   * Captcha ellenőrzése.
   * A művelet meghívja a kapott captcha kódra az ellenőrzést, és visszaadja az ellenőrzés eredményét.
   * Response generated for [ 200 ] HTTP response code.
   */
  checkCaptcha(
    args?: APIClientInterface['checkCaptchaParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.CaptchaValidationResponseDto>;
  checkCaptcha(
    args?: APIClientInterface['checkCaptchaParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.CaptchaValidationResponseDto>>;
  checkCaptcha(
    args?: APIClientInterface['checkCaptchaParams'],
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.CaptchaValidationResponseDto>>;
  checkCaptcha(
    args: APIClientInterface['checkCaptchaParams'] = {},
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.CaptchaValidationResponseDto | HttpResponse<models.CaptchaValidationResponseDto> | HttpEvent<models.CaptchaValidationResponseDto>> {
    const path = `/onlinepayment/checkcaptcha`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.post<models.CaptchaValidationResponseDto>(`${this.domain}${path}`, JSON.stringify(args.codeModel), options);
  }

  /**
   * Kupon lista
   * Adott szerződéshez tartozó kuponok lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getCoupon(
    args: Exclude<APIClientInterface['getCouponParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.HIPCouponDto[]>;
  getCoupon(
    args: Exclude<APIClientInterface['getCouponParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.HIPCouponDto[]>>;
  getCoupon(
    args: Exclude<APIClientInterface['getCouponParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.HIPCouponDto[]>>;
  getCoupon(
    args: Exclude<APIClientInterface['getCouponParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.HIPCouponDto[] | HttpResponse<models.HIPCouponDto[]> | HttpEvent<models.HIPCouponDto[]>> {
    const path = `/coupon/${args.passiveKoopFrameContractId}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.get<models.HIPCouponDto[]>(`${this.domain}${path}`, options);
  }

  /**
   * Kupon mentése
   * Adott szerződéshez tartozó kupon mentése
   * Response generated for [ 200 ] HTTP response code.
   */
  saveCoupon(
    args: Exclude<APIClientInterface['saveCouponParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.HIPCouponDto>;
  saveCoupon(
    args: Exclude<APIClientInterface['saveCouponParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.HIPCouponDto>>;
  saveCoupon(
    args: Exclude<APIClientInterface['saveCouponParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.HIPCouponDto>>;
  saveCoupon(
    args: Exclude<APIClientInterface['saveCouponParams'], undefined>,
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.HIPCouponDto | HttpResponse<models.HIPCouponDto> | HttpEvent<models.HIPCouponDto>> {
    const path = `/coupon/${args.passiveKoopFrameContractId}`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.put<models.HIPCouponDto>(`${this.domain}${path}`, JSON.stringify(args.couponCode), options);
  }

  /**
   * Kompakt szerződések lista
   * Kompakt szerződések lekérdezése
   * Response generated for [ 200 ] HTTP response code.
   */
  getKompaktContracts(
    requestHttpOptions?: HttpOptions,
    observe?: 'body',
  ): Observable<models.KompaktContractDto[]>;
  getKompaktContracts(
    requestHttpOptions?: HttpOptions,
    observe?: 'response',
  ): Observable<HttpResponse<models.KompaktContractDto[]>>;
  getKompaktContracts(
    requestHttpOptions?: HttpOptions,
    observe?: 'events',
  ): Observable<HttpEvent<models.KompaktContractDto[]>>;
  getKompaktContracts(
    requestHttpOptions?: HttpOptions,
    observe: any = 'body',
  ): Observable<models.KompaktContractDto[] | HttpResponse<models.KompaktContractDto[]> | HttpEvent<models.KompaktContractDto[]>> {
    const path = `/kompaktContracts/search`;
    const options = {
      ...this.options,
      ...requestHttpOptions,
      observe,
    };

    return this.http.get<models.KompaktContractDto[]>(`${this.domain}${path}`, options);
  }

}
